import { render, staticRenderFns } from "./ExamShow.vue?vue&type=template&id=16f12862&scoped=true&"
import script from "./ExamShow.vue?vue&type=script&lang=ts&"
export * from "./ExamShow.vue?vue&type=script&lang=ts&"
import style0 from "./ExamShow.vue?vue&type=style&index=0&id=16f12862&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f12862",
  null
  
)

export default component.exports